import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';

const labelCss = css`
  display: block;
`;

const labelTextCss = css`
  display: block;
  font-weight: bold;
  margin-bottom: 0.5rem;
`;

const FormLabel = ({
  htmlFor, id, text, children,
}) => (
  <label css={labelCss} htmlFor={htmlFor} id={id}>
    <span css={labelTextCss}>{text}</span>
    {children}
  </label>
);
FormLabel.propTypes = {
  htmlFor: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default FormLabel;
